import { RetryPlugin } from '@module-federation/retry-plugin';

const retryPlugin = () => RetryPlugin({
    fetch: {
        retryTimes: 3,
        retryDelay: 1000,
        fallback: (url) => {
            // Log the failed URL for debugging
            console.error(`[Module Federation] All fetch retries failed for: ${url}`);
            
            // If URL contains query parameters, try without them
            if (typeof url === 'string' && url.includes('?')) {
                const cleanUrl = url.split('?')[0];
                console.warn(`[Module Federation] Attempting fallback without query params: ${cleanUrl}`);
                return cleanUrl;
            }
            
            // If it's a remoteEntry.js request, try the mf-manifest.json instead
            if (typeof url === 'string' && url.includes('remoteEntry.js')) {
                const manifestUrl = url.replace('remoteEntry.js', 'mf-manifest.json');
                console.warn(`[Module Federation] Attempting manifest fallback: ${manifestUrl}`);
                return manifestUrl;
            }
            
            // Return the original URL as last resort
            return typeof url === 'string' ? url : url.toString();
        }
    },
    script: {
        retryTimes: 3,
        retryDelay: 1000,
        cb: (resolve, error) => {
            console.error('[Module Federation] Script loading failed after all retries:', error);
            // Log additional context that might help debug the issue
            console.error('[Module Federation] Context:', {
                userAgent: navigator.userAgent,
                url: window.location.href,
                timestamp: new Date().toISOString(),
                hasQueryParams: window.location.search.length > 0,
                queryParams: window.location.search
            });
            resolve(null); // Resolve with null to prevent hanging
        }
    }
});

export default retryPlugin;